export const LOAD_FORM_VERSIONS = 'LOAD_FORM_VERSIONS';
export const SET_FORM_VERSIONS_FILTER = 'SET_FORM_VERSIONS_FILTER';
export const SET_FORM_VERSIONS_PAGINATION = 'SET_FORM_VERSIONS_PAGINATION';
export const SET_FORM_VERSIONS_SORT = 'SET_FORM_VERSIONS_SORT';
export const RESET_FORM_VERSIONS_FILTERS = 'RESET_FORM_VERSIONS_FILTERS';
export const SELECT_FORM_VERSION_FOR_ROLL_OUT = 'SELECT_FORM_VERSION_FOR_ROLL_OUT';
export const CREATE_ROLL_OUT = 'CREATE_ROLL_OUT';
export const LOAD_FORM_TO_PLAN_VERSION = 'LOAD_FORM_TO_PLAN_VERSION';
export const PLAN_FORM_VERSION = 'PLAN_FORM_VERSION';
export const SIMULATE_FORM_VERSION_PLANNING = 'SIMULATE_FORM_VERSION_PLANNING';
export const TOGGLE_FORM_VERSION_STATUS = 'TOGGLE_FORM_VERSION_STATUS';
export const CREATE_JOB_RESULTS = 'CREATE_JOB_RESULTS';
export const REPORT_JOB_ERROR = 'REPORT_JOB_ERROR';
export const REPORT_ERROR_POPUP_VISIBILITY = 'REPORT_ERROR_POPUP_VISIBILITY';
export const DELETE_FORM_VERSION = 'DELETE_FORM_VERSION';
